import { render, staticRenderFns } from "./ComPopup.vue?vue&type=template&id=53baa5f0&scoped=true"
import script from "./ComPopup.vue?vue&type=script&lang=js"
export * from "./ComPopup.vue?vue&type=script&lang=js"
import style0 from "./ComPopup.vue?vue&type=style&index=0&id=53baa5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53baa5f0",
  null
  
)

export default component.exports